// extracted by mini-css-extract-plugin
export default {"eventSoldOutMessage":"SeriesNotification-rebranding-module__eventSoldOutMessage___3Kl4e"};